export default function (productCode, langCode) {
  return `${window.location.origin}/v1/static-content/html/ToU-${productCode}-${langCode}.html`;
}
